<template lang="pug">
#laudos-relatorio-territorial
    BaseHeader(
        v-if='isLaudoUnico',
        :titulo='$t("laudos.relatorioTerritorial")',
        icon='el-icon-plus',
        :btnTexto='$t("laudos.solicitarLaudo")',
        :exibeBotao='!usuarioLogado?.isAnalyst',
        @btnHeaderClicado='changeShowModalSelecionarTerritorio'
    )

    BaseHeader(
        v-else,
        :titulo='$t("laudos.titulo")',
        icon='el-icon-plus',
        :btnTexto='$t("laudos.solicitarLaudo")',
        :exibeBotao='!usuarioLogado?.isAnalyst',
        @btnHeaderClicado='changeShowModalSelecionarTerritorio'
    )

    .view-container-base-header
        .d-flex.laudo-margin
            SelecionarLaudo(@laudoUnico='atualizaLaudoUnico')

        .grid-display-laudos-dashboard
            .grid-bloco1
                h2.mb-3
                    |
                    | {{ $t('laudos.totalDeLaudos') }}
                CardTotalizadores(:dados='totalizadores')

            .grid-bloco2
                h2.mb-3
                    |
                    | {{ $t('laudos.laudosUltimos12Meses') }}
                .card-totalizadores-dashboard-laudos__grafico__tabela
                    CardTotalizadoresLaudosDashboard(
                        :dados-tabela='dadosTabela',
                        :dados-grafico='dadosGrafico'
                    )

        Filtros(@getFiltros='filtrar', :tipoLaudo='tipoLaudo')

        .titulo-tela
            h2.mb-3
                |
                | {{ $t('laudos.listagemLaudos') }}
            el-button.buttom-margin(
                type='primary',
                icon='el-icon-download',
                @click='exportarDados()'
            )
                a
                    | {{ $t('laudos.exportarDados') }}

        .lista-laudos
            LaudoListagem(
                :key="listagemTableKey('laudos', laudos, pageParams.page)",
                :tableData='laudos',
                :showAnalystColumns='usuarioLogado?.isAnalyst',
                :showCarColumn='!usuarioLogado?.isAnalyst',
                v-loading='loading',
                @handleModalLaudo='handleModalLaudo',
                @handleModalCancelamento='handleModalCancelamento',
                @handleModalInsercaoResultados='handleModalInsercaoResultados',
                @handleSort='handleSort',
                @atualizar='requestLaudos'
            )
            .px-3
                .d-flex.flex-row.justify-content-between.align-items-center.border-bottom
                    .tabela-rodape-somatorio-laudos
                        p {{ pageParams.total }} {{ $tc('laudos.contadorLaudos', pageParams.total) }}
                    el-pagination(
                        background,
                        :page-size='pageParams.size',
                        :current-page.sync='pageParams.page',
                        :pager-count='5',
                        layout='prev, pager, next',
                        :total='pageParams.total',
                        @current-change='requestLaudos'
                    )

        ModalTipoLaudo(
            :showModalSelecionarTerritorios='showModalSelecionarTerritorios',
            @setarFecharModalTipoLaudo='setarFecharModalTipoLaudo'
        )
        ModalVisualizacao(
            :idLaudo='idLaudo',
            :show.sync='showModalVisualizacao',
            :tipoLaudo='tipoLaudo'
        )
        ModalCancelamentoLaudo(
            :idLaudo='idLaudo',
            :tipoLaudo='tipoLaudo',
            :show.sync='showModalCancelamento',
            @voltar='voltar'
        )
        ModalInsercaoResultados(
            v-if='rowInfo',
            :tipoLaudo='tipoLaudo',
            :show.sync='showModalInsercaoResultados',
            :rowInfo='rowInfo',
            @update:lista='requestLaudos'
        )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import ModalVisualizacao from '@/modules/laudos/components/ModalVisualizacaoLaudo.vue';
import ModalCancelamentoLaudo from '@/modules/laudos/components/ModalCancelamentoLaudo.vue';
import ModalInsercaoResultados from '@/modules/laudos/components/ModalInsercaoResultadosLaudo.vue';
import SelecionarLaudo from '@/modules/laudos/components/SelecionarLaudo.vue';
import Filtros from '@/modules/laudos/components/filtroLaudos.vue';
import LaudoListagem from '@/modules/laudos/components/relatorioTerritorial/LaudoListagem.vue';
import CardTotalizadores from '@/modules/laudos/components/CardTotalizadores.vue';
import CardTotalizadoresLaudosDashboard from '@/modules/laudos/views/dashboard/CardTotalizadoresLaudosDashboard.vue';
import TipoLaudo from '@/modules/laudos/constants/TipoLaudo';
import ModalTipoLaudo from '@/modules/laudos/components/ModalTipoLaudo.vue';
import LaudoService from '@/modules/laudos/services/LaudosService';
import { mapGetters } from 'vuex';
import formatters from '@/modules/laudos/utils/formatters';

export default {
    name: 'LaudoRelatorioTerritorial',
    components: {
        BaseHeader,
        SelecionarLaudo,
        LaudoListagem,
        ModalVisualizacao,
        ModalCancelamentoLaudo,
        ModalTipoLaudo,
        ModalInsercaoResultados,
        Filtros,
        CardTotalizadores,
        CardTotalizadoresLaudosDashboard
    },
    computed: {
        ...mapGetters(['usuarioLogado'])
    },
    data() {
        return {
            tipoLaudo: TipoLaudo.RELATORIO_TERRITORIAL,
            dadosGrafico: {
                loading: true,
                erro: false,
                payload: {
                    colunas: [],
                    itens: []
                }
            },
            dadosTabela: {
                loading: true,
                erro: false,
                payload: {
                    colunas: [],
                    itens: [],
                    visualizar: false
                }
            },
            showModalVisualizacao: false,
            showModalCancelamento: false,
            showModalSelecionarTerritorios: false,
            showModalConfirmarTerritorios: false,
            territoriosSelecionados: [],
            pageParams: {
                page: 1,
                size: 20,
                total: 0,
                sort: 'dataCadastro,DESC'
            },
            filtros: {
                dataCadastroFim: '',
                dataCadastroInicio: '',
                dataFinalizacaoFim: '',
                dataFinalizacaoInicio: '',
                representantesCpfCnpj: [],
                situacaoIds: [],
                statusId: '',
                territoriosIds: [],
                tipoLaudoId: TipoLaudo.RELATORIO_TERRITORIAL
            },
            laudos: [],
            idLaudo: null,
            rowInfo: null,
            showModalInsercaoResultados: false,
            usuariosBuffer: {},
            loading: false,
            isLaudoUnico: false,
            totalizadores: {}
        };
    },
    methods: {
        exportarDados() {
            LaudoService.exportXlsx(this.tipoLaudo)
                .then(() => {
                    this.$notify.success({
                        message: this.$t('laudos.exportacaoRealizadaComSucesso')
                    });
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('laudos.erroAoRealizarExportacao')
                    });
                });
        },
        async getLaudos() {
            await this.requestLaudos();
            await this.requestTotalizadores();
            await this.buscarTotalizadoresSituacaoMensal();
        },

        setarFecharModalTipoLaudo() {
            this.showModalSelecionarTerritorios = false;
            this.getLaudos();
        },

        changeShowModalSelecionarTerritorio() {
            this.showModalSelecionarTerritorios =
                !this.showModalSelecionarTerritorios;
        },

        changeShowModalConfirmarTerritorios() {
            this.showModalConfirmarTerritorios =
                !this.showModalConfirmarTerritorios;
        },

        solicitarLaudos(territoriosSelecionados) {
            this.changeShowModalSelecionarTerritorio();
            this.changeShowModalConfirmarTerritorios();
            this.territoriosSelecionados = territoriosSelecionados;
        },

        voltar() {
            this.changeShowModalConfirmarTerritorios();
            this.getLaudos();
        },
        handleModalLaudo(laudo) {
            this.showModalVisualizacao = !this.showModalVisualizacao;
            this.idLaudo = laudo;
        },
        handleModalCancelamento(laudo) {
            this.showModalCancelamento = !this.showModalCancelamento;
            this.idLaudo = laudo;
        },
        async handleSort(paramsProp) {
            this.pageParams = {
                page: this.pageParams?.page,
                size: 20,
                sort: `${paramsProp?.column},${paramsProp?.order}`
            };
            await this.getLaudos();
        },
        handleModalInsercaoResultados(rowInfo) {
            this.rowInfo = rowInfo;
            this.showModalInsercaoResultados =
                !this.showModalInsercaoResultados;
        },
        async filtrar(filtros) {
            this.filtros = { ...filtros };
            await this.getLaudos();
        },

        async requestLaudos() {
            try {
                this.loading = true;
                const { data } = await LaudoService.requestLaudos(
                    this.filtros,
                    this.pageParams
                );
                this.pageParams.total = data?.totalItens || 0;
                this.laudos = data?.laudos;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'laudos.erro.naoFoiPossivelCarregarOsDados'
                    )
                });
            } finally {
                this.loading = false;
            }
        },

        async requestTotalizadores() {
            try {
                const { data } = await LaudoService.buscarTotalizadoresSituacao(
                    this.filtros.tipoLaudoId
                );
                this.totalizadores = data;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'laudos.erro.naoFoiPossivelCarregarOsDadosDosTotalizadores'
                    )
                });
            } finally {
                this.loading = false;
            }
        },

        atualizarDadosTabela(itens) {
            this.dadosTabela = {
                loading: false,
                erro: false,
                payload: {
                    colunas: [
                        this.$t('laudos.meses'),
                        this.$t('laudos.solicitados'),
                        this.$t('laudos.naFila'),
                        this.$t('laudos.emProcessamento'),
                        this.$t('laudos.processado'),
                        this.$t('laudos.cancelado'),
                        this.$t('laudos.falhaNoProcessamento')
                    ],
                    codigo: [
                        'meses',
                        'solicitados',
                        'naFila',
                        'emProcessamento',
                        'processados',
                        'cancelado',
                        'falhaProcessamento'
                    ],
                    itens: itens,
                    visualizar: false
                }
            };
        },
        atualizarDadosGrafico(
            colunas,
            solicitados,
            naFila,
            emProcessamento,
            processados,
            cancelado,
            falhaProcessamento
        ) {
            let itens = [];
            itens.push({
                name: this.$t('laudos.solicitados'),
                data: solicitados
            });
            itens.push({
                name: this.$t('laudos.naFila'),
                data: naFila
            });
            itens.push({
                name: this.$t('laudos.emProcessamento'),
                data: emProcessamento
            });
            itens.push({
                name: this.$t('laudos.processado'),
                data: processados
            });
            itens.push({
                name: this.$t('laudos.cancelado'),
                data: cancelado
            });
            itens.push({
                name: this.$t('laudos.falhaNoProcessamento'),
                data: falhaProcessamento
            });
            this.dadosGrafico = {
                loading: false,
                erro: false,
                payload: {
                    colunas: colunas,
                    itens: itens
                }
            };
        },

        async buscarTotalizadoresSituacaoMensal() {
            const { data } =
                await LaudoService.buscarTotalizadoresSituacaoMensal(
                    this.tipoLaudo
                );

            let itens = [];
            let colunas = [];
            let solicitados = [];
            let naFila = [];
            let emProcessamento = [];
            let processados = [];
            let cancelado = [];
            let falhaProcessamento = [];
            for (const element of data) {
                colunas.push(element.mesAbreviado);
                solicitados.push(element.solicitados);
                naFila.push(element.naFila);
                emProcessamento.push(element.emProcessamento);
                processados.push(element.processados);
                cancelado.push(element.cancelado);
                falhaProcessamento.push(element.falhaProcessamento);
                itens.push({
                    mes: element.mesDescricao,
                    solicitados: this.formatNumber(element.solicitados),
                    naFila: this.formatNumber(element.naFila),
                    emProcessamento: this.formatNumber(element.emProcessamento),
                    processados: this.formatNumber(element.processados),
                    cancelado: this.formatNumber(element.cancelado),
                    falhaProcessamento: this.formatNumber(
                        element.falhaProcessamento
                    )
                });
            }
            this.atualizarDadosTabela(itens);
            this.atualizarDadosGrafico(
                colunas,
                solicitados,
                naFila,
                emProcessamento,
                processados,
                cancelado,
                falhaProcessamento
            );
        },

        formatNumber(number) {
            return formatters.formatNumber(number, 0);
        },

        atualizaLaudoUnico(laudoUnico) {
            this.isLaudoUnico = laudoUnico === 'true';
        }
    }
};
</script>

<style scoped lang="scss">
#laudos-relatorio-territorial {
    .laudo-margin {
        margin-bottom: 20px;
        background-color: var(--white);
        width: 100%;
        padding: 16px;
        overflow: hidden;
        border-radius: 4px;
    }

    .lista {
        background: var(--white);
        border-radius: 4px;
        overflow: hidden;
        min-height: 55vh;
        max-height: 72vh;
    }

    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .titulo-tela {
        display: flex;
        justify-content: space-between;
        align-items: flex-end !important;
        height: 45px;
    }

    .buttom-margin {
        margin-bottom: 5px;
    }
}
</style>
